<template>
  <div id="app" class="app" ref="app">
    <!--  顶部导航兰  -->
    <header-bar v-if="!isMobile" />
    <!--  页面容器  -->
    <router-view />
    <!--  底部  -->
    <footer-bar v-if="!isMobile" />
  </div>
</template>

<script>
import HeaderBar from "@/components/HeaderBar.vue";
import FooterBar from "@/components/FooterBar.vue";

export default {
  name: "App",
  components: {
    HeaderBar,
    FooterBar,
  },
  data() {
    return {
      isMobile: false,
      show: true,
      height: 0,
    };
  },
  mounted() {},
  methods: {
    scrollHandle(e) {
      if (e.srcElement.scrollingElement.scrollTop > this.height) {
        this.show = false;
      } else {
        this.show = true;
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.isMobile = flag
      return flag;
    }

  },
};
</script>
<style lang="less">
@import "./assets/font/font.css";

* {
  margin: 0;
  padding: 0;
}

.app {
  font-family: Noto Sans SC !important;
  font-weight: lighter;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #000;
  width: 100%;
  overflow-x: hidden;
  font-weight: 400;
}


div {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

li {
  list-style: none;
}

img {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue